module.exports = __webpack_public_path__ + "static/img/banner-img.285f609.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mesuggestions/banner-img.png
// module id = DBQh
// module chunks = 44